$(document).ready(function(){ // cart quantity updates

  // delegate click for plus button
  $(document).on('click', '.i_plus_cart', function(){
      var plus, currrent_qty;
      let $inputBox = $(this).closest('.line_changer').find('input.quantity-input');
      
      currrent_qty = parseInt($inputBox.val()) || 0;
      plus = currrent_qty + 1;
      $inputBox.val(plus);

      var variant_id = $(this).closest('.line_changer').attr("line_var_id");
      updateCartItem(variant_id, plus, 'plus'); 
  });

  // delegate click for minus button
  $(document).on('click', '.i_minus_cart', function(){
      var minus;
      let $inputBox = $(this).closest('.line_changer').find('input.quantity-input');

      minus = parseInt($inputBox.val()) - 1;
      $inputBox.val(minus);

      var variant_id = $(this).closest('.line_changer').attr("line_var_id");
      updateCartItem(variant_id, minus, 'minus'); 
  });

  // optional: if needed for Nectar coins
  $(document).on('click', '#nector-useyourcoins-container', function(){
      // justRefresh(); 
  });

  // trigger when cart is updated
  document.addEventListener("cart:change", function(){
      setTimeout(function(){
          // No need to re-attach events now
      }, 2000);
  }); 

  // update cart items
  function updateCartItem(variant_id, quantity, operation){
      var data = { updates: {} };
      var item_count;

      data.updates[variant_id] = quantity;

      $(".loading_wait").show();
      $(".loading_overlay").show();

      jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function(result) { 
              $.when( 
                  jQuery.getJSON('/cart.js', function(cart) {
                      item_count = cart.item_count;
                      let cartData = cart.items;
                      document.dispatchEvent(new CustomEvent('cart:build' ,{
                          bubbles: true
                      })); 
                      document.dispatchEvent(new CustomEvent('cart:refresh', {
                          bubbles: true,
                          detail: cartData
                      })); 
                  })
              ).then(function(){
                  setTimeout(function(){
                      $(".header__cart-count").find(".count-bubble").html(item_count);
                      $(".loading_wait").hide();
                      $(".loading_overlay").hide();
                  }, 2000);
              });
          },
          error: function(xhr, status, error) {
              // console.log("Status:", xhr.status);
      
              $(".loading_wait").hide();
              $(".loading_overlay").hide();
              $('.line_changer[line_var_id="'+variant_id+'"] input').val(function(_, val) {
                  return Math.max(1, val - 1); // Ensures the value does not go below 1
              });

              let message = $('<p style="color:red;">Not Enough Inventory</p>').insertAfter('.line_changer[line_var_id="'+variant_id+'"]');
              setTimeout(function() {
                  message.fadeOut(300, function() {
                      $(this).remove();
                  });
              }, 2000);
              
          }
      });
  }

  // refresh cart state (not used actively)
  function justRefresh(){
    var data = { updates: {} };
    var item_count;

    $(".loading_wait").show();
    $(".loading_overlay").show();

    jQuery.ajax({
        type: 'GET',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(result) { 
            $.when( 
                jQuery.getJSON('/cart.js', function(cart) {
                    item_count = cart.item_count;
                    let cartData = cart.items;
                    document.dispatchEvent(new CustomEvent('cart:build' ,{
                        bubbles: true
                    })); 
                    document.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true,
                        detail: cartData
                    })); 
                })
            ).then(function(){
                setTimeout(function(){
                    $(".loading_wait").hide();
                    $(".loading_overlay").hide();
                }, 2000);
            });
        }
    });
  }

});


$(document).ready(function () { // mega-menu: hover shows products (desktop), click follows link
  function activateMegaMenuItem($item) {
    if (!$item.length || $item.hasClass("active")) return;

    $("li.main_menu_cu").removeClass("active").each(function () {
      const $span = $(this).find("> a > span");
      $span.css("transform", "translateX(0)");
      $span.css("padding-left", "16px");
      $span.find(".red-dot").remove();
    });

    $item.addClass("active");

    const $span = $item.find("> a > span");
    $span.css("transform", "translateX(18px)");
    $span.css("padding-left", "0");

    if ($span.find(".red-dot").length === 0) {
      $("<div class='red-dot'></div>").prependTo($span);
    }

    $("ul.sub_menu_cu").removeClass("show");
    const $child_mm = $item.find("ul.sub_menu_cu");
    if ($child_mm.length > 0) {
      $child_mm.addClass("show");
    }
  }

  const desktopMq = window.matchMedia("(min-width: 1150px)");

  function bindMegaMenuInteraction() {
    $("li.main_menu_cu").off("click.megaMenuCu mouseenter.megaMenuCu");

    if (desktopMq.matches) {
      // Above 1149px: switch product panels on hover (skip last item); click navigates via the <a> href
      $("li.main_menu_cu").on("mouseenter.megaMenuCu", function () {
        if ($(this).is(":last-child")) return;
        activateMegaMenuItem($(this));
      });

      const $items = $("li.main_menu_cu").not(":last-child");
      const $active = $items.filter(".active");
      activateMegaMenuItem($active.length ? $active.first() : $items.first());
    }
  }

  bindMegaMenuInteraction();
  if (desktopMq.addEventListener) {
    desktopMq.addEventListener("change", bindMegaMenuInteraction);
  } else if (desktopMq.addListener) {
    desktopMq.addListener(bindMegaMenuInteraction);
  }
});

document.addEventListener('DOMContentLoaded', () => { // tranform first letters to italic from matched keywords array
  // const keywords = ["inbalance", "unkissed"];
  const keywordInput = document.getElementById("italickeywordsglobal");
  const keywords = keywordInput?.value?.split('+') || [];

  function walkAndReplaceTextNodes(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      let originalText = node.textContent;

      keywords.forEach(word => {
        // Match full word case-insensitively
        const regex = new RegExp(`\\b(${word})\\b`, 'gi');

        originalText = originalText.replace(regex, (match) => {
          const firstTwo = match.slice(0, 2);
          const rest = match.slice(2);
          return `<i style="font-family: inherit !important; font-weight: inherit;">${firstTwo}</i>${rest}`;
        });
      });

      if (originalText !== node.textContent) {
        const temp = document.createElement('div');
        temp.innerHTML = originalText;

        const fragment = document.createDocumentFragment();
        while (temp.firstChild) {
          fragment.appendChild(temp.firstChild);
        }

        node.parentNode.replaceChild(fragment, node);
      }

    } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE') {
      Array.from(node.childNodes).forEach(walkAndReplaceTextNodes);
    }
  }

  walkAndReplaceTextNodes(document.body);
});

document.addEventListener("DOMContentLoaded", function() { // remove comma from price
  document.querySelectorAll(".price, .money").forEach(function(el) {
    el.textContent = el.textContent.replace(/,/g, "");
  });
});

(function () { // close accordion when current one is opened
  const SEL = 'details[is="accordion-disclosure"], accordion-disclosure';

  function isAccordion(el) {
    return !!el && (el.matches?.(SEL));
  }

  // Find the group container so we only close siblings in the same block/section.
  function getGroupRoot(acc) {
    // Prefer a nearby ancestor that actually contains multiple accordions.
    let node = acc.parentElement;
    for (let i = 0; i < 6 && node; i++) {
      const count = node.querySelectorAll(SEL).length;
      if (count > 1) return node;
      node = node.parentElement;
    }
    return acc.parentElement || document; // safe fallback
  }

  function closeSiblingsOf(acc) {
    const root = getGroupRoot(acc);
    const list = root.querySelectorAll(SEL);
    list.forEach((other) => {
      if (other !== acc && other.open) {
        // Use the component's own API so Impact's animation runs
        other.open = false;
      }
    });
  }

  // 1) Capture click on <summary> before Impact toggles 'open'
  document.addEventListener('click', function (e) {
    const summary = e.target.closest('summary');
    if (!summary) return;

    const acc = summary.closest(SEL);
    if (!isAccordion(acc)) return;

    // If it's currently closed, it's about to open -> close others first
    // (We are in capture phase, before the theme flips open state)
    if (!acc.open) {
      closeSiblingsOf(acc);
    }
  }, true); // <- capture

  // 2) Also watch for programmatic opens (Theme Editor, JS) and enforce one-open rule
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        const acc = m.target;
        if (isAccordion(acc) && acc.open) {
          closeSiblingsOf(acc);
        }
      }
    }
  });

  mo.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });

  // Optional: re-enforce after Shopify section loads in editor/live
  document.addEventListener('shopify:section:load', (evt) => {
    const root = evt.target || document;
    root.querySelectorAll(SEL).forEach((acc) => {
      if (acc.open) closeSiblingsOf(acc);
    });
  });
})();

/* Open Bitespeed back-in-stock popup from collection/product card Notify Me */
(function () {
  var NOTIFY_SEL = '.js-notify-me, .bag-quickadd--notify > a, .bag-quickadd--notify > button';

  function getBackInStockPopup() {
    if (!window.bitespeed_popups) return null;
    var popups = Object.values(window.bitespeed_popups);
    return (
      popups.find(function (p) {
        return String((p && p.behaviour && p.behaviour.When && p.behaviour.When.selected) || '')
          .toLowerCase()
          .indexOf('out of stock') !== -1;
      }) || popups[0] || null
    );
  }

  function openNotifyMePopup(productId, variantId) {
    var popup = getBackInStockPopup();
    if (!popup || typeof popup.show !== 'function' || !productId || !variantId) {
      return false;
    }
    popup.show('', true, {
      popupTrigger: 'back_in_stock',
      productId: String(productId),
      variantId: String(variantId),
    });
    return true;
  }

  function blockCardNavigation(event) {
    var btn = event.target.closest && event.target.closest(NOTIFY_SEL);
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    return btn;
  }

  function handleNotifyClick(event) {
    var btn = blockCardNavigation(event);
    if (!btn) return;

    var productId = btn.getAttribute('data-product-id');
    var variantId = btn.getAttribute('data-variant-id');
    if (!openNotifyMePopup(productId, variantId)) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (openNotifyMePopup(productId, variantId) || tries >= 15) {
          clearInterval(timer);
        }
      }, 200);
    }
  }

  // Block product-card <a> on pointerdown; open popup on click
  document.addEventListener('pointerdown', blockCardNavigation, true);
  document.addEventListener('click', handleNotifyClick, true);
})();
